const qaPath = 'https://test.autotrader.com';
const prodPath = 'https://www.autotrader.com';
export default {
  dev: {
    accountApiPath: '/account-api/',
    userAccountApiPath: '/account/auth-user/',
    remoteApiPath: qaPath + '/rest/myatc/',
    myAtcApiPath: qaPath + '/rest/myatcauth/v0/',
    personalizationInventoryApiPath: 'https://test.autotrader.com/rest/pl/v0/',
    psxNotificationsApiPath: '/psx-notifications',
    myatcManifestPath: '/client/js/manifest.json',
    inventoryApiPath: qaPath + '/rest/',
    env: 'DEV'
  },
  qa: {
    accountApiPath: '/account-api/',
    userAccountApiPath: '/account/auth-user/',
    remoteApiPath: qaPath + '/rest/myatc/',
    myAtcApiPath: qaPath + '/rest/myatcauth/v0/',
    personalizationInventoryApiPath: 'https://test.autotrader.com/rest/pl/v0/',
    psxNotificationsApiPath: '/psx-notifications',
    myatcManifestPath: 'https://test.autotrader.com/my-autotrader/client/js/manifest.json',
    inventoryApiPath: qaPath + '/rest/',
    env: 'QA'
  },
  prod: {
    accountApiPath: '/account-api/',
    userAccountApiPath: '/account/auth-user/',
    remoteApiPath: prodPath + '/rest/myatc/',
    myAtcApiPath: prodPath + '/rest/myatcauth/v0/',
    personalizationInventoryApiPath: prodPath + '/rest/pl/v0/',
    psxNotificationsApiPath: '/psx-notifications',
    myatcManifestPath: '/my-autotrader/client/js/manifest.json',
    inventoryApiPath: prodPath + '/rest/',
    env: 'PROD'
  },
  test: {
    accountApiPath: 'https://test.foo/account-api/',
    userAccountApiPath: '/account/auth-user/',
    remoteApiPath: 'https://test.foo/rest/myatc/',
    myAtcApiPath: 'https://test.foo/rest/myatcauth/v0/',
    personalizationInventoryApiPath: 'https://test.foo/rest/pl/v0/',
    psxNotificationsApiPath: '/psx-notifications',
    myatcManifestPath: 'https://test.autotrader.com/my-autotrader/client/js/manifest.json',
    inventoryApiPath: 'https://test.foo/rest/',
    env: 'TEST'
  }
};